module.exports = __webpack_public_path__ + "img/2.b92059c3.png";